import React from 'react';
export function PriorityMatrix() {
  return <div className="relative bg-white rounded-xl shadow-lg overflow-hidden border-2 border-slate-200" data-id="element-103">
      {/* Axis Labels */}
      <div className="absolute top-2 left-1/2 -translate-x-1/2 text-xs font-bold uppercase text-slate-500 tracking-wider z-10" data-id="element-104">
        Feasibility →
      </div>
      <div className="absolute left-2 top-1/2 -translate-y-1/2 -rotate-90 text-xs font-bold uppercase text-slate-500 tracking-wider z-10" data-id="element-105">
        ← Impact
      </div>

      {/* Matrix Grid */}
      <div className="p-12" data-id="element-106">
        <div className="grid grid-cols-2 grid-rows-2 gap-2" data-id="element-107">
          {/* Low Impact / Low Feasibility */}
          <div className="border-2 border-slate-200 rounded-lg p-6 h-32 flex items-center justify-center bg-slate-50" data-id="element-108">
            <span className="text-slate-400 text-sm text-center font-medium" data-id="element-109">
              Deprioritize
            </span>
          </div>

          {/* Low Impact / High Feasibility */}
          <div className="border-2 border-slate-200 rounded-lg p-6 h-32 flex items-center justify-center bg-slate-50" data-id="element-110">
            <span className="text-slate-400 text-sm text-center font-medium" data-id="element-111">
              Quick Wins
            </span>
          </div>

          {/* High Impact / Low Feasibility */}
          <div className="border-2 border-slate-200 rounded-lg p-6 h-32 flex items-center justify-center bg-orange-50" data-id="element-112">
            <span className="text-orange-600 text-sm text-center font-medium" data-id="element-113">
              Future Bets
            </span>
          </div>

          {/* High Impact / High Feasibility - HIGHLIGHTED */}
          <div className="border-2 border-blue-600 rounded-lg p-6 h-32 flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 shadow-lg relative overflow-hidden" data-id="element-114">
            <div className="absolute top-0 right-0 w-16 h-16 bg-blue-600 transform rotate-45 translate-x-8 -translate-y-8" data-id="element-115"></div>
            <strong className="text-blue-600 text-lg font-bold relative z-10" data-id="element-116">
              TOP 3 PILOTS
            </strong>
            <p className="text-xs text-blue-700 mt-1 relative z-10" data-id="element-117">
              High Impact × High Feasibility
            </p>
          </div>
        </div>
      </div>

      {/* Axis Value Labels */}
      <div className="absolute bottom-2 left-1/4 text-xs font-semibold text-slate-400" data-id="element-118">
        LOW
      </div>
      <div className="absolute bottom-2 right-1/4 text-xs font-semibold text-slate-400" data-id="element-119">
        HIGH
      </div>
      <div className="absolute top-1/4 left-2 text-xs font-semibold text-slate-400 -rotate-90" data-id="element-120">
        HIGH
      </div>
      <div className="absolute bottom-1/4 left-2 text-xs font-semibold text-slate-400 -rotate-90" data-id="element-121">
        LOW
      </div>
    </div>;
}